import { apiUrl } from "../ApiManager/AxiosHeaders";

export async function fetchAllActivePolicies() {
  const response = await apiUrl.get("/fetch-active-policies", {
    params: { page: 1, perPage: 200 },
  });

  const payload = response?.data || {};
  if (!payload.success) {
    throw new Error(payload.message || "Failed to load policies.");
  }

  return payload.data || [];
}

export async function assignUserPolicies(userIds = [], policyIds = []) {
  const response = await apiUrl.post("/assign-user-policies", {
    user_ids: userIds.map(Number),
    policy_ids: policyIds.map(Number),
  });

  const payload = response?.data || {};
  if (!payload.success) {
    throw new Error(payload.message || "Failed to assign policies.");
  }

  return payload;
}

export async function fetchUserPolicies(userId) {
  const response = await apiUrl.get(`/user-policies/${userId}`);
  const payload = response?.data || {};

  if (!payload.success) {
    throw new Error(payload.message || "Failed to load user policies.");
  }

  return payload.data?.policies || [];
}

export function buildUserPolicyMap(policies = []) {
  const map = new Map();

  policies.forEach((policy) => {
    (policy.assigned_user_ids || []).forEach((userId) => {
      const key = String(userId);
      if (!map.has(key)) map.set(key, new Set());
      map.get(key).add(Number(policy.id));
    });
  });

  return map;
}

/** Users already assigned to at least one selected policy — pre-check in assign modal. */
export function getAlreadyAssignedUserIds(policies = [], selectedPolicyIds = new Set()) {
  const assigned = new Set();

  policies
    .filter((policy) => selectedPolicyIds.has(String(policy.id)))
    .forEach((policy) => {
      (policy.assigned_user_ids || []).forEach((userId) => assigned.add(String(userId)));
    });

  return assigned;
}

/** Users already assigned to every selected policy. */
export function getFullyAssignedUserIds(policies = [], selectedPolicyIds = new Set()) {
  if (!selectedPolicyIds.size) return new Set();

  const selectedPolicies = policies.filter((policy) => selectedPolicyIds.has(String(policy.id)));
  if (!selectedPolicies.length) return new Set();

  let intersection = null;

  selectedPolicies.forEach((policy) => {
    const ids = new Set((policy.assigned_user_ids || []).map(String));
    if (intersection === null) {
      intersection = ids;
    } else {
      intersection = new Set([...intersection].filter((id) => ids.has(id)));
    }
  });

  return intersection || new Set();
}

export function mergePolicyIdsForUser(userPolicyMap, userId, selectedPolicyIds = []) {
  const existing = userPolicyMap.get(String(userId)) || new Set();
  const merged = new Set([...existing, ...selectedPolicyIds.map((id) => Number(id))]);
  return [...merged];
}
